module.exports = __webpack_public_path__ + "static/img/title1-3.7f32982.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity2023114/title1-3.png
// module id = KiE5
// module chunks = 0